import PropTypes from 'prop-types';
import { Badge } from '@openedx/paragon';
import { FILE_TYPES } from '../data/files';

const FileTypeBadge = ({ type }) => {
  const meta = FILE_TYPES[type];
  if (!meta) { return null; }
  return (
    <Badge pill size="sm" variant={meta.badgeVariant} color={meta.badgeColor}>
      {meta.label}
    </Badge>
  );
};

FileTypeBadge.propTypes = {
  type: PropTypes.oneOf(Object.keys(FILE_TYPES)).isRequired,
};

export default FileTypeBadge;
